function changeColumnnName(columnName: string) {
  /**
   * This function is for changing the column name for the CSV
   * Feature Name --> Feature Category
   * Resources --> Resource
   * Mandays Spent --> Billable Days
   */

  switch (columnName) {
    case 'Feature Name': {
      return 'Feature Category';
    }
    case 'Resources': {
      return 'Resource';
    }
    case 'Mandays Spent': {
      return 'Billable Days';
    }
    default: {
      return columnName;
    }
  }
}

function camelCaseToSentence(camelCase: string) {
  let result = camelCase.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

function generateColumnName(columnKey: string) {
  return changeColumnnName(camelCaseToSentence(columnKey));
}

export default function json2csv(json: Array<Record<string, unknown>>) {
  let csv = ``;
  let arrOfColumnKey = Object.keys(json[0]);
  let arrOfColumnSentence = arrOfColumnKey.map((data) =>
    generateColumnName(data),
  );
  let columnLength = arrOfColumnKey.length;

  // Append the column key
  arrOfColumnSentence.forEach((data, i) => {
    // Last key
    if (i === arrOfColumnKey.length - 1) {
      csv += `${data}\n`;
    } else {
      csv += `${data},`;
    }
  });

  // Append the content
  json.forEach((data) => {
    arrOfColumnKey.forEach((key, j) => {
      if (j === columnLength - 1) {
        csv += `${data[key]}`;
      } else {
        csv += `${data[key]},`;
      }
    });
    csv += `\n`;
  });

  return csv;
}
